import { useCallback, useEffect, useState } from 'react'

/**
 * Counts down whole seconds after `start(seconds)`. Computed from a deadline
 * rather than by decrementing, so it stays accurate if the tab is throttled in
 * the background (timers slow down, but the wall clock does not).
 */
export const useCountdown = () => {
  const [deadline, setDeadline] = useState<number | null>(null)
  const [now, setNow] = useState(() => Date.now())

  const active = deadline !== null && now < deadline

  useEffect(() => {
    if (!active) return
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [active])

  const start = useCallback((seconds: number) => {
    const startedAt = Date.now()
    setNow(startedAt)
    setDeadline(startedAt + seconds * 1000)
  }, [])

  const remaining = deadline === null ? 0 : Math.max(0, Math.ceil((deadline - now) / 1000))

  return { remaining, start }
}
